import { AppStore } from '@bd/store-modules';

export const getPredefinedMeetingTypes = (store: AppStore) => {
  return store.state.staticData?.predefinedMeetingTypes
}

export const arePredefinedMeetingTypesFetched = (store: AppStore) => {
  return !!getPredefinedMeetingTypes(store)?.content
}
